export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "newest_first": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Plus récents"])},
        "oldest_first": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Plus anciens"])},
        "export_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Exporter"])},
        "assignee_unassigned": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Non assigné"])}
      },
      "en": {
        "newest_first": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Newest first"])},
        "oldest_first": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Oldest first"])},
        "export_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Export"])},
        "assignee_unassigned": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Unassigned"])}
      }
    }
  })
}
